import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a numeric "sunset hour" (e.g. 7.5 or 12.25) to a clock-like string.
 * assumes the decimal number is the actual representation ie 22.5 is 22:50, not 22:30
 */
@Pipe({ name: 'hourFormat' })
export class HourFormatPipe implements PipeTransform {
  transform(value: number | null | undefined): string | null {
    const result = toStringHour(value);
    return result;
  }
}

export function toStringHour(value: number | null | undefined): string | null {
  if (value == null || isNaN(value) || value < 0) return null;

  let str = value.toString().replace('.', ':');

  if (value < 10) {
    str = '0' + str;
  }

  if(str.length === 2) {
      return str + ':00';
  }

  if (str.length === 4) { 
      return str + '0';
  }

  return str;
}
